import React from "react";
import {
  Card,
  Stack,
  Text,
  Group,
  Avatar,
  ThemeIcon,
  Button,
  Box,
} from "@mantine/core";
import {
  IconUsers,
  IconCalendarTime,
  IconEye,
  IconMail,
  IconUserPlus,
  IconBrandLinkedin,
  IconPhone,
  IconRocket,
} from "@tabler/icons-react";
import { useCampaignStore } from "../../../../../stores/CampaignStore";

const CampaignSummary = () => {
  const programData = useCampaignStore((s) => s.programData);
  const agentId = useCampaignStore((s) => s.agentId);
  return (
    <Stack gap="md" w={"30%"}>
      {/* CARTE RÉCAPITULATIF */}
      <Card
        withBorder
        radius="xl"
        p="xl"
        style={{ borderColor: "var(--mantine-color-gray-2)" }}
      >
        <Stack gap="lg">
          <Text fw={700} size="lg" c="dark">
            Récapitulatif
          </Text>

          {/* Ligne 1 : Agent (Utilisation de l'Avatar) */}
          <Group wrap="nowrap" gap="md">
            <Avatar radius="xl" size="lg" />
            <Text size="lg">
              <Text component="span" fw={700} c="dark">
                Emma
              </Text>{" "}
              <Text component="span" c="dimmed">
                · SDR — Software RH
              </Text>
            </Text>
          </Group>

          {/* Ligne 2 : Audience */}
          <Group wrap="nowrap" gap="md">
            <ThemeIcon variant="light" color="violet.5" radius="xl" size="md">
              <IconUsers size={18} stroke={1.5} />
            </ThemeIcon>
            <Text size="md">
              <Text component="span" fw={700} c="dark">
                DRH — Scale-ups France
              </Text>{" "}
              <Text component="span" c="dimmed">
                · 1284 contacts
              </Text>
            </Text>
          </Group>

          {/* Ligne 3 : Durée */}
          <Group wrap="nowrap" gap="md">
            <ThemeIcon variant="light" color="violet.5" radius="xl" size="md">
              <IconCalendarTime size={18} stroke={1.5} />
            </ThemeIcon>
            <Text size="md" fw={600}>
              6 étapes · 18 jours
            </Text>
          </Group>

          {/* Ligne 4 : Séquence de canaux */}
          <Group gap={8} mt={4}>
            <ThemeIcon variant="outline" radius="xl" size={32} color="blue.6">
              <IconEye size={16} />
            </ThemeIcon>
            <ThemeIcon variant="outline" radius="xl" size={32} color="violet.5">
              <IconMail size={16} />
            </ThemeIcon>
            <ThemeIcon variant="outline" radius="xl" size={32} color="blue.6">
              <IconUserPlus size={16} />
            </ThemeIcon>
            <ThemeIcon variant="outline" radius="xl" size={32} color="violet.5">
              <IconMail size={16} />
            </ThemeIcon>
            <ThemeIcon variant="outline" radius="xl" size={32} color="blue.6">
              <IconBrandLinkedin size={16} />
            </ThemeIcon>
            <ThemeIcon variant="outline" radius="xl" size={32} color="teal.6">
              <IconPhone size={16} />
            </ThemeIcon>
          </Group>
        </Stack>
      </Card>

      {/* BOUTON DE LANCEMENT */}
      <Button
        size="xl"
        radius="xl"
        color="violet.5"
        fullWidth
        leftSection={<IconRocket size={24} stroke={1.5} />}
        styles={{
          label: { fontSize: 18, fontWeight: 700 },
        }}
      >
        Lancer la campagne
      </Button>
    </Stack>
  );
};

export default CampaignSummary;
